import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { SharedModule } from 'shared/shared.module';

@Component({
    selector: 'app-scheduled-reports-email-settings-modal',
    templateUrl: './scheduled-reports-email-settings-modal.component.html',
    styleUrls: ['./scheduled-reports-email-settings-modal.component.scss'],
    imports: [SharedModule, TranslateModule, ReactiveFormsModule],
})
export class ScheduledReportsEmailSettingsModalComponent extends BaseModal {
    public set data(value: any) {
        this.emailSettingsDefaults = value.emailSettingsDefaults;
        this.form = value.form as FormGroup;
    }

    public form?: FormGroup;
    private emailSettingsDefaults!: { subject: string; body: string };

    constructor() {
        super();
    }

    public resetForm() {
        this.form!.patchValue(this.emailSettingsDefaults);
    }

    public closeModal(data?: any) {
        this.closeModalInstance(data);
    }
}
